import { jsx } from 'react/jsx-runtime';
import { SVG } from './utils/style.svg.js';
import { getDefaultHeight } from './utils/get-default-height.js';

const ExitFullscreenIcon = ({
  color = "currentColor",
  ...svgProps
}) => {
  return /*#__PURE__*/jsx(SVG, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    height: getDefaultHeight(svgProps, 24),
    ...svgProps,
    fill: svgProps.fill ?? "none",
    stroke: color ?? svgProps.stroke ?? "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    children: /*#__PURE__*/jsx("path", {
      d: "M1 15.7h7.3V23M23 8.3h-7.3V1m0 22v-7.3H23M8.3 1v7.3H1"
    })
  });
};

export { ExitFullscreenIcon };
//# sourceMappingURL=fullscreen.exit.js.map
